module.exports = __webpack_public_path__ + "static/fonts/Fact-ExpandedThin.84f1c0a.woff";